export var TeamInviteSourceType;
(function (TeamInviteSourceType) {
    TeamInviteSourceType["email"] = "Email";
    TeamInviteSourceType["link"] = "Link";
})(TeamInviteSourceType || (TeamInviteSourceType = {}));
export var TeamInviteDeviceType;
(function (TeamInviteDeviceType) {
    TeamInviteDeviceType["mobile"] = "Mobile";
    TeamInviteDeviceType["desktop"] = "Desktop";
})(TeamInviteDeviceType || (TeamInviteDeviceType = {}));
